define([
    "jquery",
    "underscore",
	"backbone",
	"google_analytics"
], function($, _, Backbone, GoogleAnalytics) {

    return Backbone.View.extend({
        el: '#content_layout',

        events:{
			'click .print_btn': 'print'
        },

        initialize: function(){
			GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.bankwire_open);
		},

		initBody: null,

		beforePrint: function( id) {
			this.initBody = document.body.innerHTML;
			document.body.innerHTML = document.getElementById(id).innerHTML;
		},

		afterPrint: function() {
			document.body.innerHTML = this.initBody;
			this.setElement( $('#content_layout'));
		},

		print: function(e) {
			e.preventDefault();

			var id = $(e.currentTarget).attr('for');
			window.onbeforeprint = this.beforePrint(id);
			window.print();
			window.onafterprint = this.afterPrint();
		},
    });
});
